/* unplugin-vue-components disabled */import { render } from "./IntroAvatarViewer.vue?vue&type=template&id=742835d5&scoped=true"
import script from "./IntroAvatarViewer.vue?vue&type=script&lang=js"
export * from "./IntroAvatarViewer.vue?vue&type=script&lang=js"

import "./IntroAvatarViewer.vue?vue&type=style&index=0&id=742835d5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-742835d5"]])

export default __exports__